namespace $.$$ {

	$mol_style_define( $shm_ba_agent_message_posts, {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		minWidth: 0,
		width: '100%',

		Empty: {
			color: $mol_theme.shade,
		},
	} )

}
